<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import SwiperCore, { Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import Swal from "sweetalert2";
import attributeProduct from "./attributeProduct.vue";

SwiperCore.use([Pagination, Navigation]);

export default {
    page: {
        title: "Products Details",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Products Details",
            items: [
                {
                text: "Device Management",
                href: "/",
                },
                {
                text: "Products Details",
                active: true,
                },
            ],
            product_info: [],
            categorylist: [],
            devicemodelList: [],
            colorList: [],
            capacityList: [],
            product_name: '',
            model_id: '',
            category_id: '',
            capacity_id: '',
            color_id: '',
            color_hex_code: '',
            owned: '',
            status: '',
            image: '',

        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },

        get_branch_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.product_info = response.data;
                    this.product_name = this.product_info[0].product_name;
                    this.image = this.product_info[0].image;
                    this.model_id = this.product_info[0].model_id;
                    this.category_id = this.product_info[0].category_id;
                    this.capacity_id = this.product_info[0].capacity_id;
                    this.color_id = this.product_info[0].color_id;
                    this.color_hex_code = this.product_info[0].color_hex_code;
                    this.owned = this.product_info[0].owned;
                    this.status = this.product_info[0].status;
                                
                    console.log(this.branch_info);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        update_product(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                product_name: this.product_name,
                model_id: this.model_id,
                category_id: this.category_id,
                capacity_id: this.capacity_id,
                color_id: this.color_id,
                color_hex_code: this.color_hex_code,
                owned: this.owned,
                status: this.status,
            };

            if (typeof this.$route.params.id !== 'undefined') {
                this.url = process.env.VUE_APP_API_BASEURL+'product/update/'+this.$route.params.id;
            }else{
                this.url = process.env.VUE_APP_API_BASEURL+'product/create';
            }

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(this.url, posting_)
            .then( response => {
                if (response.status == 200) {
                    if (typeof this.$route.params.id === 'undefined') {
                        this.product_name = '';
                        this.model_id = '';
                        this.category_id = '';
                        this.capacity_id = '';
                        this.color_id = '';
                        this.color_hex_code = '';
                        this.owned = '';
                        this.status = '';
                    }

                    Swal.fire({
                        title: response.data.message,
                        icon: 'success',
                        showConfirmButton: false,
                    });
                } else {
                    Swal.fire({
                    title: response.data.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    });
                }
            })
        },

        //raw data----------------------------------------------------------
        get_category(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'category/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.categorylist = response.data;
                    console.log(this.categorylist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_model(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device_model/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.devicemodelList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_capacity(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'capacity/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.capacityList = response.data;
                    console.log(this.capacityList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_color(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'color/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.colorList = response.data;
                    console.log(this.colorList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        selectNewCategory(category_id) {
            this.get_category(); // Refresh the category list to include the new one
            this.category_id = category_id; // Set the new category as selected
        },

        selectNewModel(model_id) {
            this.get_model(); // Refresh the category list to include the new one
            this.model_id = model_id; // Set the new category as selected
        },

        selectNewCapacity(capacity_id) {
            this.get_capacity(); // Refresh the category list to include the new one
            this.capacity_id = capacity_id; // Set the new category as selected
        },

        selectNewColor(color_id) {
            this.get_color(); // Refresh the category list to include the new one
            this.color_id = color_id; // Set the new category as selected
        },

        //raw data----------------------------------------------------------

        imageRoot(){
            return process.env.VUE_APP_IMAGE_BASEURL;
        },
    },

    components: {
        Layout,
        PageHeader,
        Swiper,
        SwiperSlide,
        attributeProduct,
    },

    mounted() { 
        if (typeof this.$route.params.id !== 'undefined') {
            this.get_branch_by_id();
        }
        this.get_category();
        this.get_model();
        this.get_capacity();
        this.get_color();   
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row gx-lg-5">
              <div class="col-xl-4 col-md-8 mx-auto">
                <div class="product-img-slider sticky-side-div">
                  <swiper
                    class="product-thumbnail-slider p-2 rounded bg-light"
                    :loop="false"
                    :spaceBetween="24"
                    :navigation="{
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    }"
                    :thumbs="{
                      swiper: {
                        loop: false,
                        spaceBetween: 10,
                        slidesPerView: 1,
                        freeMode: true,
                        watchSlidesProgress: true,
                      },
                    }"
                  >
                    <swiper-slide>
                      <img :src="`${ imageRoot() }` + image" alt="" class="img-fluid d-block" />
                    </swiper-slide>                                                        
                  </swiper>            
                  <!-- end swiper nav slide -->
                </div>
              </div>
              <!-- end col -->

              <div class="col-xl-8">
                <div class="mt-xl-0 mt-5">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                        <h4><span class="badge badge-soft-primary badge-border">{{ product_name }}</span></h4>
                        <hr class="my-4 text-muted">
                        <div class="live-preview">
                            <form @submit="update_product" class="row g-3">
                                <div class="col-md-12">
                                <label for="product_name" class="form-label">Product Name</label>
                                <input v-model='product_name' type="text" class="form-control" id="product_name"/>
                                </div>

                                <div class="col-md-6">
                                <label for="category" class="form-label">
                                    Category
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#addCategoryModal">
                                        <i class="ri-add-circle-line"></i>
                                    </a>
                                </label>
                                <select v-model="category_id" class="form-select mb-3" arial-label="Default select example" required>
                                    <option value="">--- Select Category ---</option>
                                    <option v-for="(item, index) in categorylist" :key="index" :value="item.id" >
                                        {{ item.name }}
                                    </option>
                                </select>
                                </div>
                                <div class="col-md-6">
                                <label for="model" class="form-label">
                                    Model
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#addModelModal">
                                        <i class="ri-add-circle-line"></i>
                                    </a>

                                </label>
                                <select v-model="model_id" class="form-select mb-3" arial-label="Default select example" required>
                                    <option value="">--- Select Model ---</option>
                                    <option v-for="(item, index) in devicemodelList" :key="index" :value="item.id" >
                                        {{ item.model_name }}
                                    </option>
                                </select>
                                </div>

                                <div class="col-md-6">
                                <label for="capacity" class="form-label">
                                    Capacity
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#addCapacityModal">
                                        <i class="ri-add-circle-line"></i>
                                    </a>

                                </label>
                                <select v-model="capacity_id" class="form-select mb-3" arial-label="Default select example" required>
                                    <option value="">--- Select Capacity ---</option>
                                    <option v-for="(item, index) in capacityList" :key="index" :value="item.id" >
                                        {{ item.name }}
                                    </option>
                                </select>
                                </div>
                                <div class="col-md-6">
                                <label for="color" class="form-label">
                                    Color
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#addColorModal">
                                        <i class="ri-add-circle-line"></i>
                                    </a>

                                </label>
                                <select v-model="color_id" class="form-select mb-3" arial-label="Default select example" required>
                                    <option value="">--- Select Color ---</option>
                                    <option v-for="(item, index) in colorList" :key="index" :value="item.id" >
                                        {{ item.name }}
                                    </option>
                                </select>
                                </div>

                                <div class="col-md-6">
                                <label for="color_hex_code" class="form-label">Color Hex Code</label>
                                <input v-model='color_hex_code' type="text" class="form-control" id="color_hex_code"/>
                                </div>
                                <div class="col-md-6">
                                <label for="owned" class="form-label">Pre Owned</label>
                                <input v-model='owned' type="text" class="form-control" id="owned"/>
                                </div>
                                
                                <div class="col-md-6">
                                    <label for="status" class="form-label">Status</label>
                                    <div class="live-preview">
                                        <div class="list-group">
                                            <label class="list-group-item">
                                                <input
                                                    class="form-check-input fs-14 mt-0 align-middle me-1"
                                                    name="status"
                                                    v-model="status"
                                                    type="radio"
                                                    value="0"                                                                    
                                                                                                                
                                                />
                                                Enable
                                            </label>
                                            <label class="list-group-item">
                                                <input
                                                    class="form-check-input fs-14 mt-0 align-middle me-1"
                                                    name="status"
                                                    v-model="status"
                                                    type="radio"
                                                    value="1"                                                                                                                                                                                                          
                                            />
                                                Disable
                                            </label>
                                            
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-12">
                                <div class="text-end" >
                                    <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="submit" class="btn btn-primary" v-if="this.role != 3">
                                    Update/Create
                                    </button>
                                </div>
                                </div>
                            </form>
                            </div>
                    </div>                  
                  </div>
                  <!-- product-content -->     
                  <!-- end card body -->
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <attributeProduct @category-added="selectNewCategory" @model-added="selectNewModel" @capacity-added="selectNewCapacity" @color-added="selectNewColor"></attributeProduct>
    <!-- end row -->
  </Layout>
</template>
